import {
  AnalyticsBrowser,
  InitOptions,
} from "@customerio/cdp-analytics-browser";
import Store from "~/common/Store";
import { getHashedCustomerEmail } from "~/userAnalytics";
import { setAnalyticsBrowser } from "./loadAnalyticsBrowser";
import isMobile from "../../common/helpers/isMobile";
import { sendCustomerIoMobilePageViewEvent } from "./CustomerIoEvents";
import { env } from "~/common/Environment";
import Bowser from "bowser";
import getABFeatureFlag from "~/common/Featbit/getABFeatureFlag";
import { logException } from "@wss/error-tracking";
import { defaultUserObject } from "~/common/Store/rootReducer";

const writeKey = env.isProd ? "b274e5d7e1c8ea9f94cf" : "a2add68a2309306bfc05";
const siteId = env.isProd ? "1760163a8fa7753d6c07" : "dc7a833c13bd3ae01b38";

const usingChromeOnIos = !!Bowser.ios && !!Bowser.chrome;

const options: InitOptions = {
  integrations: {
    "Customer.io In-App Plugin": {
      siteId,
      anonymousInApp: true,
    },
  },
};

const analytics = AnalyticsBrowser.load(
  { writeKey },
  /** Optional: Add in-app messaging support
   * We specifically exclude Chrome on iOS due to an issue marking the site as unsecure
   * coming from the following request: https://engine-consumer-api.cloud.gist.build/api/v2/configuration?cioSiteId=1760163a8fa7753d6c07&cioDatacenter=null&random=1750855936589
   * that is loaded only when the in-app messaging plugin is enabled.
   */
  usingChromeOnIos ? undefined : options,
);

const loadCustomerIoAnalytics = async () => {
  setAnalyticsBrowser(analytics);
  const cioUser = await analytics.user();
  const { user } = Store.getState();
  const cioUserId = cioUser.id();

  const result = await getABFeatureFlag(
    {
      featureFlagName: "reset-cio-users",
      defaultValue: "false",
      customProps: [],
    },
    {
      sessionId: defaultUserObject.sessionId,
      emailAddress: defaultUserObject.emailAddress,
    },
  );

  if (result.isError) {
    logException(result.error);
  }
  const resetCioUsers = result.isError
    ? false
    : result.value.stringValue === "true";
  // If the featbit flag to make all users anonymous is enabled, call reset on all customers with a cioUserId
  // Only call reset if they have a cioUserId, otherwise it will reset the anonymous user Id assigned already
  if (resetCioUsers) {
    if (cioUserId) {
      analytics.reset();
    }
  } else {
    if (user.emailAddress && !cioUserId) {
      const hashedEmail = getHashedCustomerEmail(user.emailAddress);
      analytics.identify(hashedEmail, {
        email: user.emailAddress,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      });
    } else if (!user.emailAddress && cioUserId) {
      analytics.reset();
    }
  }
  analytics.page();
  if (isMobile()) {
    sendCustomerIoMobilePageViewEvent();
  }
};

export default loadCustomerIoAnalytics;
